/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-19 18:16:20
 * @LastEditors: Json Chen
 * @LastEditTime: 2021-07-09 13:16:20
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelContentPage/EditorPage/tools.ts
 */
import { randomNumber } from '@/src/tools/helper';
import {
  generateBody,
  initContentBody,
  initContentError,
} from 'src/constrains/DraggableModules/tools';
import { convertSpecificError } from 'src/constrains/SalesChannelPreviewPageComponents/tools';
import { EnumCollapseId } from './slice';

import _ from 'lodash';
import {
  generateCollapseErrorMsgDisplay,
  generateCollapseOpen,
  isInPCorNative,
} from 'src/constrains/SalesChannelPreviewPageComponents/tools';
import { validateFloatingActionsBar } from 'src/pages/SalesChannelContentEditor/Components/FloatingActionsBar/tools';
import {
  fixedCollapse,
  generateDefaultIconStyle,
  generateDefaultPageSetting,
  generateDefaultSeoSetting,
} from 'src/pages/SalesChannelContentEditor/SalesChannelContentPage/EditorPage/common';
import { reduxUpdatedStatusControl } from 'src/tools/helper';
import { EnumContentPageStatus } from 'src/types/common/SalesChannel';

const setFloatingBarButtonsDraggableId = (floatingBar) => {
  return Object.assign({}, floatingBar || {}, {
    buttons: ((floatingBar || {}).buttons || []).map((b) => ({
      draggableId: randomNumber(),
      ...b,
    })),
  });
};

const validatePageSetting = (pageSetting, skipValidation) => {
  const specificErr = {};
  const { alwaysOn, name, endTime, endDate, beginTime, beginDate } =
    pageSetting || {};

  specificErr['nameError'] = [];
  specificErr['timePickerError'] = [];
  if (!name) {
    specificErr['nameError'].push('name 不能为空');
  }

  if (
    !alwaysOn &&
    !(endTime && endDate && beginTime && beginDate) &&
    !skipValidation
  ) {
    specificErr['timePickerError'].push('time 不能为空');
  }
  return {
    hasError: convertSpecificError(specificErr).length > 0,
    specificError: specificErr,
    generalError: [],
  };
};

const validateSeoSetting = (seoSetting, isPrimary) => {
  const generalError = [];
  const specificErr = {};
  specificErr['slugError'] = [];
  const { slugValid } = seoSetting;
  if (!slugValid && isPrimary) {
    specificErr['slugError'].push(
      'A page already exists with the same url slug.',
    );
  }

  return {
    hasError: convertSpecificError(specificErr).length > 0,
    specificError: specificErr,
    generalError,
  };
};

// const validateFloatingActionsBar = (floatingActionsBar) => {
//   const { buttons = [] } = floatingActionsBar;
//   const generalError = [];

//   const specificError = buttons.reduce((a, b) => {
//     a[b['draggableId'] + 'buttonsErr'] = [];
//     return a;
//   }, {});

//   let hasError = false;

//   for (let i = 0; i < buttons.length; i++) {
//     const b = buttons[i];

//     if (!b.name || !b.icon || !b.linkModule) {
//       hasError = true;
//       specificError[b['draggableId'] + 'buttonsErr'].push(
//         'Link and icon cannot be empty.',
//       );
//     }
//   }

//   return {
//     hasError,
//     specificError,
//     generalError,
//   };
// };

const convertInitDataFromServerToRedux = (data) => {
  const {
    timezoneInGmt,
    contentUuid,
    salesChannelContent,
    salesChannelName,
    uuid,
    floatingBar,
    miniProgramShare,
    miniProgramPageInfo,
    name,
  } = data;
  const _pageSetting = generateDefaultPageSetting();

  return {
    contentUuid,
    salesChannelContent,
    salesChannelName,
    uuid,
    ...reduxUpdatedStatusControl,
    floatingBar: setFloatingBarButtonsDraggableId(floatingBar),
    timezoneInGmt,
    miniProgramShare: miniProgramShare || {},
    miniProgramPageInfo: miniProgramPageInfo || {},
    pageSetting: { ..._pageSetting, name },
    //floatingBar,
  };
};

const convertDataFromServerToRedux = (data, isPrimary) => {
  //const { hasErrorCollapse } = queries || {};
  const {
    contentBody = [],
    contentUuid,
    salesChannelContent,
    salesChannelName,
    seoSetting,
    iconStyle,
    uuid,
    name,
    beginDate,
    beginTime,
    endDate,
    endTime,
    alwaysOn,
    hasError: hasErrorCollapse,
    timezoneInGmt,
    floatingBar,
    miniProgramShare,
    miniProgramPageInfo,
    status,
    breakpoint,
    siteStyle,
    contentPages,
    translationEnabled = false,
  } = data;

  const inUsePages = (contentPages || []).filter(
    (p) => p.status === EnumContentPageStatus.InUse,
  );

  const isNew = !uuid;

  const _isInPC = isInPCorNative(siteStyle, breakpoint);

  const moduleContentOrder = [];
  const moduleContentStaticConfig = {};
  const moduleContentDynamicConfig = {};
  const collapseOpen = generateCollapseOpen(fixedCollapse);
  const collapseErrorMsgDisplay = generateCollapseErrorMsgDisplay(
    fixedCollapse,
    !isNew,
  );

  const _iconStyle = generateDefaultIconStyle();
  const _seoSetting = generateDefaultSeoSetting();
  const _pageSetting = generateDefaultPageSetting();
  const pageSetting = {
    name: name || _pageSetting.name,
    beginDate: beginDate || _pageSetting.beginDate,
    beginTime: beginTime || _pageSetting.beginTime,
    endDate: endDate || _pageSetting.endDate,
    endTime: endTime || _pageSetting.endTime,
    alwaysOn: alwaysOn,
    status,
  };

  initContentBody({
    contentBody,
    moduleContentOrder,
    isNew,
    collapseOpen,
    collapseErrorMsgDisplay,
    moduleContentDynamicConfig,
    moduleContentStaticConfig,
  });

  const _a = {
    moduleContentOrder,
    moduleContentStaticConfig,
    moduleContentDynamicConfig,
    collapseOpen,
    contentUuid,
    salesChannelContent,
    salesChannelName,
    seoSetting: seoSetting || _seoSetting,
    iconStyle: iconStyle || _iconStyle,
    pageSetting,
    uuid,
    translationEnabled,
    collapseErrorMsgDisplay,
    ...reduxUpdatedStatusControl,
    timezoneInGmt,
    floatingBar: setFloatingBarButtonsDraggableId(floatingBar),
    miniProgramShare: miniProgramShare || {},
    miniProgramPageInfo: miniProgramPageInfo || {},
  };

  if (!isNew && hasErrorCollapse) {
    let flag = false;
    if (_isInPC) {
      const { hasError: pageSettingHasError } = validatePageSetting(
        pageSetting,
        !isPrimary,
      );
      if (pageSettingHasError) {
        _a.collapseErrorMsgDisplay[EnumCollapseId.pageSetting].hasError = true;
        _a.collapseErrorMsgDisplay[EnumCollapseId.pageSetting].display = true;

        _a.collapseOpen[EnumCollapseId.pageSetting] = true;
        flag = true;
      }

      const { hasError: seoHasError } = validateSeoSetting(
        _a.seoSetting,
        isPrimary,
      );
      if (seoHasError) {
        _a.collapseErrorMsgDisplay[EnumCollapseId.seoSetting].hasError = true;
        _a.collapseErrorMsgDisplay[EnumCollapseId.seoSetting].display = true;
        if (!flag) {
          flag = true;
          _a.collapseOpen[EnumCollapseId.seoSetting] = true;
        }
      }
    } else {
      const { hasError: pageSettingHasError } = validatePageSetting(
        pageSetting,
        !isPrimary,
      );
      if (pageSettingHasError) {
        _a.collapseErrorMsgDisplay[EnumCollapseId.pageSetting].hasError = true;
        _a.collapseErrorMsgDisplay[EnumCollapseId.pageSetting].display = true;

        _a.collapseOpen[EnumCollapseId.pageSetting] = true;
        flag = true;
      }

      const { hasError: seoHasError } = validateSeoSetting(
        _a.seoSetting,
        isPrimary,
      );
      if (seoHasError) {
        _a.collapseErrorMsgDisplay[EnumCollapseId.seoSetting].hasError = true;
        _a.collapseErrorMsgDisplay[EnumCollapseId.seoSetting].display = true;
        if (!flag) {
          flag = true;
          _a.collapseOpen[EnumCollapseId.seoSetting] = true;
        }
      }
      const { hasError: floatingBarHasError } = validateFloatingActionsBar(
        _a.floatingBar,
        isPrimary,
      );
      if (floatingBarHasError) {
        _a.collapseErrorMsgDisplay[EnumCollapseId.floatingBar].hasError = true;
        _a.collapseErrorMsgDisplay[EnumCollapseId.floatingBar].display = true;
        if (!flag) {
          flag = true;
          _a.collapseOpen[EnumCollapseId.floatingBar] = true;
        }
      }
    }

    initContentError({
      flag,
      moduleContentDynamicConfig,
      _a,
      moduleContentOrder,
      moduleContentStaticConfig,
      validationProps: { contentPages: inUsePages, breakpoint, siteStyle },
    });
  }

  return _a;
};

const validateTopCollapses = (state) => {
  // const { hasError: seoHasError } = validateSeoSetting(state.seoSetting);
  // if (seoHasError) {
  //   //state.collapseOpen[EnumCollapseId.seoSetting] = true;
  //   state.collapseErrorMsgDisplay[EnumCollapseId.seoSetting].hasError = true;
  //   state.collapseErrorMsgDisplay[EnumCollapseId.seoSetting].display = true;
  // }
  // const { hasError: pageSettingHasError } = validatePageSetting(
  //   state.pageSetting,
  // );
  // if (pageSettingHasError) {
  //   state.collapseErrorMsgDisplay[EnumCollapseId.pageSetting].hasError = true;
  //   state.collapseErrorMsgDisplay[EnumCollapseId.pageSetting].display = true;
  //   //state.collapseOpen[EnumCollapseId.pageSetting] = true;
  // }
};

const convertDataFromReduxToServer = (state) => {
  const _state = _.cloneDeep(state);

  const {
    moduleContentOrder,
    moduleContentStaticConfig,
    moduleContentDynamicConfig,
    iconStyle,
    seoSetting,
    contentUuid,
    uuid,
    pageSetting,
    floatingBar,
    miniProgramShare,
    miniProgramPageInfo,
  } = _state;

  const _body = generateBody({
    moduleContentDynamicConfig,
    moduleContentOrder,
    moduleContentStaticConfig,
  });

  return {
    miniProgramShare,
    miniProgramPageInfo,
    iconStyle,
    seoSetting,
    contentUuid,
    contentBody: _body,
    uuid,
    floatingBar,
    ...(pageSetting || {}),
  };
};

export {
  validatePageSetting,
  validateSeoSetting,
  validateFloatingActionsBar,
  fixedCollapse,
  convertDataFromServerToRedux,
  convertDataFromReduxToServer,
  convertInitDataFromServerToRedux,
  validateTopCollapses,
};
